/**
* Controller for a single group
* @author Ryan Gladstone
*/

function GroupOverviewController(
  $scope,
  $stateParams,
  $log,
  groupsService,
  taskTriggersService,
  navigationService
) {
  navigationService.navigateGroup('groups.group.overview');

  const groupId = $stateParams.groupId;

  groupsService.getGroup(groupId)
    .then((data) => {
      $scope.group = data;
      $scope.newGroupName = data.name;
    }, (response) => {
      $log.error('GroupOverviewController getGroup() error: ', response);
    });

  taskTriggersService.getTriggers({ assignedGroup: groupId })
    .then((response) => {
      $scope.triggers = response.results;
    }, (response) => {
      $log.error('GroupOverviewController getTriggers() error: ', response);
    });
}

const arr = [
  '$scope',
  '$stateParams',
  '$log',
  'groupsService',
  'taskTriggersService',
  'navigationService',
  GroupOverviewController
];

module.exports = (ngModule) => {
  ngModule.controller('GroupOverviewController', arr);
};
